import React from "react";
import IPostGridVerifySingleAddress from "../../../../models/PostGrid/IPostGridVerifySingleAddress";
import INewAddress from "../../../../models/INewAddress";
import OwButton from "../../OwButton/OwButton";

type Props = {
    initialAddress: INewAddress;
    data: IPostGridVerifySingleAddress;
    useCorrectedAddressFn: (data: IPostGridVerifySingleAddress) => void;
    useOriginalAddressFn: () => void;
};

export const AddressCorrectionModal = (props: Props) => {
    return (
        <div className={"AddressCorrectionModal p-2"}>
            <div className={"AddressCorrectionModal__header"}>
                <h3>Address Correction</h3>
            </div>
            <div className={"AddressCorrectionModal__body d-flex"}>
                <div className={"AddressCorrectionModal__body__address w-50 me-4"}>
                    <div className={"AddressCorrectionModal__body__address__header"}>
                        <h4>Original Address</h4>
                    </div>
                    <div className={"AddressCorrectionModal__body__address__body"}>
                        <div>{props.initialAddress.address_line_one}</div>
                        <div>{props.initialAddress.address_line_two}</div>
                        <div>
                            {props.initialAddress.city}, {props.initialAddress.state} {props.initialAddress.postal_code}
                        </div>
                    </div>
                </div>
                <div className={"AddressCorrectionModal__body__address w-50 flex-grow"}>
                    <div className={"AddressCorrectionModal__body__address__header"}>
                        <h4>Corrected Address</h4>
                    </div>
                    <div className={"AddressCorrectionModal__body__address__body d-flex flex-column flex-grow"}>
                        <div>{props.data.data.line1}</div>
                        <div>
                            {props.data.data.city}, {props.data.data.provinceOrState} {props.data.data.postalOrZip}
                        </div>
                    </div>
                </div>
            </div>
            <div className={"d-flex"}>
                <div className={"w-50 mt-3"}>
                    <OwButton className={"btn btn-secondary"} fn={props.useOriginalAddressFn}>
                        Use Original Address
                    </OwButton>
                </div>
                <div className={"w-50 mt-3"}>
                    <OwButton
                        className={"btn btn-primary me-2"}
                        fn={() => {
                            props.useCorrectedAddressFn(props.data);
                        }}>
                        Use Corrected Address
                    </OwButton>
                </div>
            </div>
        </div>
    );
};
